document.addEventListener('DOMContentLoaded', loadCartUpsells);

document.addEventListener('DOMContentLoaded', () => {
  if (sessionStorage.getItem('openCartAfterUpsell') === '1') {
    sessionStorage.removeItem('openCartAfterUpsell');

    setTimeout(() => {
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }, 200);
  }
});

async function loadCartUpsells() {
  const wrapper = document.querySelector('#cart-upsells');

  if (!wrapper) return;

  const productId = wrapper.dataset.productId;
  const content = wrapper.querySelector('.cart-upsells__content');

  if (!productId || !content) return;

  try {
    const response = await fetch(
      `/recommendations/products.json?product_id=${productId}&limit=6&intent=related`
    );

    if (!response.ok) return;

    const data = await response.json();
    const products = data.products || [];

    if (!products.length) {
      wrapper.style.display = 'none';
      return;
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const cartProductIds = cart.items.map(item => item.product_id);

    const recommendations = products
      .filter(product =>
        product.available &&
        !cartProductIds.includes(product.id)
      )
      .slice(0, 2);

    if (!recommendations.length) {
      wrapper.style.display = 'none';
      return;
    }

    content.innerHTML = recommendations.map(product => {
      const variant =
        product.variants.find(variant => variant.available) ||
        product.variants[0];

      const price =
        `${(variant.price / 100).toFixed(2).replace('.', ',')} €`;

      return `
        <div class="cart-upsell">

          <a href="${product.url}" class="cart-upsell__image">
            ${
              product.featured_image
                ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">`
                : ''
            }
          </a>

          <div class="cart-upsell__info">

            <a href="${product.url}" class="cart-upsell__title">
              ${product.title}
            </a>

            <span class="cart-upsell__price">
              ${price}
            </span>

          </div>

          <button
            type="button"
            class="cart-upsell__button"
            data-variant-id="${variant.id}"
          >
            + Añadir
          </button>

        </div>
      `;
    }).join('');

    wrapper
      .querySelectorAll('.cart-upsell__button')
      .forEach(button => {

        button.addEventListener('click', async () => {

          const variantId = button.dataset.variantId;

          button.disabled = true;
          button.textContent = 'Añadiendo...';

          try {

            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: Number(variantId),
                  quantity: 1
                }]
              })
            });

            sessionStorage.setItem(
              'openCartAfterUpsell',
              '1'
            );

            window.location.reload();

          } catch (error) {

            button.disabled = false;
            button.textContent = '+ Añadir';

          }

        });

      });

  } catch (error) {

    console.error(
      'Error cargando recomendaciones:',
      error
    );

  }
}